import { useEffect, useRef } from "react";

// Match on e.code, not e.key: on macOS Option composes a glyph (⌥P → π, ⇧⌥P → ∏).
export function usePlanModeShortcut(onToggle: () => void, enabled = true) {
  const ref = useRef(onToggle);
  // oxlint-disable-next-line react/react-compiler -- blocks React Compiler; remove when fixed
  ref.current = onToggle;

  useEffect(() => {
    if (!enabled) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.shiftKey &&
        e.altKey &&
        !e.metaKey &&
        !e.ctrlKey &&
        e.code === "KeyP"
      ) {
        e.preventDefault();
        ref.current();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [enabled]);
}
